import Vuetify from 'vuetify'

export default new Vuetify({
    theme: {
        dark: false,
        themes: {
            light: {
                // primary: '#42a5f5'
                // primary: colors.purple,
            },
            dark: {
                // primary: '#2196F3'
            }
        }
    },
    options: {
        customProperties: false
    },
    icons: {
        iconfont: 'md' // default is 'mdi'
    }
})
